<template>
    <div v-if="assessment.countriesOrBasins.length > 1" class="country-basin-ct">
        <div 
            v-for="countryOrBasin of countriesOrBasins" :key="countryOrBasin[assessment.assessmentType.idPropertyName]"
            @click="select(countryOrBasin)"
            :class="{active: countryOrBasin == assessment.countriesOrBasins[0]}"
            class="country-basin-item"
        >
            {{countryOrBasin.name}}
        </div>
    </div>
</template>

<script>
import { assessment } from "@/services/assessment-model.js";
import * as _ from 'lodash';

export default {
    name: "CountryOrBasinSelector",
    data() {
        return {
            assessment: assessment
        }
    },
    computed: {
        countriesOrBasins() {
            return _.orderBy(assessment.countriesOrBasins, ["name"]);
        }
    },
    methods: {
        select(countryOrBasin) {
            const idPropertyName = assessment.assessmentType.idPropertyName;
            if (assessment.countriesOrBasins[0][idPropertyName] == countryOrBasin[idPropertyName]) {
                return;
            }
            
            const otherCountriesOrBasins = _.filter(assessment.countriesOrBasins, cb => cb[idPropertyName] != countryOrBasin[idPropertyName]);
            this.assessment.countriesOrBasins = [countryOrBasin, ...otherCountriesOrBasins];
        }
    }
}
</script>

<style lang="scss" scoped>
.country-basin-ct {
    display: flex;
    margin-bottom: 10px;
}

.country-basin-item {
    cursor: pointer;
    background-color: white;
    padding: 5px 10px;
    border: 1px solid #edebe5;
    border-radius: 5px;
    margin-right: 10px;
    &.active {
        background-color: #009bd1;
        color: white;
        border-color: #009bd1;
    }
}
</style>
